// extracted by mini-css-extract-plugin
export var Slider = "GalleryModal-module--Slider--0lD7H";
export var Facts = "GalleryModal-module--Facts--apNiH";
export var TName = "GalleryModal-module--TName--Be8rx";
export var TValue = "GalleryModal-module--TValue--WPBLK";
export var PHeader = "GalleryModal-module--PHeader--v3tAS";
export var PDescription = "GalleryModal-module--PDescription--57cm7";
export var TriggerLeft = "GalleryModal-module--TriggerLeft---BXXJ";
export var TriggerRight = "GalleryModal-module--TriggerRight--56xbE";